import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onBeforeMount } from 'vue';
import { useRouter } from 'vue-router/composables';
import ThemeCard from '@/components/common/theme/theme-card.vue';
import { ModuleName } from '@/types/module-type';
import { MerchantDpList, MerchantItem } from '@/types/merchant';
import { ThemeCardType } from '@/types';
import { useConfigStore } from '@/store';
import { JAPAN_DUAL_COLUMN_LEFT_INDEX, JAPAN_DUAL_COLUMN_RIGHT_INDEX } from '@/config/module-config/japan';


export default /*#__PURE__*/_defineComponent({
  __name: 'dual-column',
  props: {
    moduleName: null
  },
  emits: ['onHideModule'],
  setup(__props: any, { emit }) {

const props = __props as { moduleName: ModuleName }




const router = useRouter();
const { getConfig } = useConfigStore();

const leftColumn = ref<MerchantDpList | null>(null);
const rightColumn = ref<MerchantDpList | null>(null);

const filterValidMerchants = (list: MerchantItem[] = []) => list.filter(item => item.title).slice(0, 3);
const leftValidList = computed(() => filterValidMerchants(leftColumn.value?.merchantList));
const rightValidList = computed(() => filterValidMerchants(rightColumn.value?.merchantList));

function goToMerchantDetail(contentPosition: string) {
  router.push({ name: 'merchantDetail', query: { id: contentPosition } });
}

onBeforeMount(async () => {
  const result = await getConfig(props.moduleName);
  const allList: MerchantDpList[] = result?.merchantDpList || [];
  const left = allList[JAPAN_DUAL_COLUMN_LEFT_INDEX];
  const right = allList[JAPAN_DUAL_COLUMN_RIGHT_INDEX];

  if (left?.merchantList?.length) {
    leftColumn.value = left;
  }
  if (right?.merchantList?.length) {
    rightColumn.value = right;
  }

  if (!leftColumn.value && !rightColumn.value) {
    emit('onHideModule', props.moduleName);
  }
});

return { __sfc: true,props, emit, router, getConfig, leftColumn, rightColumn, filterValidMerchants, leftValidList, rightValidList, goToMerchantDetail, ThemeCard, ThemeCardType }
}

})